/* eslint-disable @typescript-eslint/no-shadow */
import { add } from 'date-fns';
import { isEmpty } from 'lodash-es';

import apiUrls from '@/apiUrls.config';
import { genUuidForCookie } from '~/storeServices/uuidForCookie';

import { makeMutations } from '../helper-functions/store/store';

export const state = () => ({
  schowekIlosc: 0,
  klientId: '',
  schowekBloczki: null,
  kluczBloczkow: null,
});
export const mutations = {
  ...makeMutations(['schowekIlosc', 'schowekBloczki', 'kluczBloczkow']),
  setKlientId(state) {
    if (!process.client) return;

    const klientId = this.$cookies.get('KlientIdSchowek');
    const uuid = genUuidForCookie();

    if (isEmpty(klientId)) {
      this.$cookies.set('KlientIdSchowek', uuid, {
        expires: add(Date.now(), { years: 1 }),
      });
      state.klientId = uuid;
    } else {
      state.klientId = klientId;
    }
  },
};
export const getters = {
  getSchowekIlosc(state) {
    return state.schowekIlosc;
  },
  getKluczBloczkow(state) {
    return state.kluczBloczkow;
  },
};
export const actions = {
  async setSchowekIlosc({ commit, state, dispatch }) {
    try {
      commit('setKlientId');
      let response = 0;

      if (state.klientId) {
        response = await this.$http.$get(`${apiUrls.schowek}rozmiar?KlientId=${state.klientId}`);
      }

      commit('schowekIlosc', response);
      dispatch('pobierzSchowek');
      return response;
    } catch (err) {
      console.log(err);
      return null;
    }
  },
  async pobierzSchowek({ commit, state }) {
    try {
      commit('setKlientId');
      let response = [];

      if (state.klientId) {
        response = await this.$http.$get(`${apiUrls.schowek}pobierz?KlientId=${state.klientId}`);
      }

      commit('kluczBloczkow', response ? response.map((bloczek) => bloczek.Klucz) : null);
      commit('schowekBloczki', response);
    } catch (err) {
      console.log(err);
    }
  },
  async akcjaSchowke({ state, commit, dispatch }, payload) {
    try {
      commit('setKlientId');
      const klucz = `${payload.BazoweInformacje.HotelID}_${payload.BazoweInformacje.ImprezaID}`;

      if (state.kluczBloczkow && state.kluczBloczkow.includes(klucz)) {
        const bloczekId = state.schowekBloczki.find((e) => e.Klucz === klucz).Bloczek.BloczekId;

        dispatch('usunElementZSchowka', bloczekId);
      } else {
        dispatch('dodajElementDoSchowka', payload);
      }
    } catch (err) {
      console.log(err);
    }
  },
  async usunElementZSchowka({ state, dispatch }, payload) {
    try {
      await this.$http.$delete(`${apiUrls.schowek}usun?KlientId=${state.klientId}&BloczekId=${payload}`);
      dispatch('setSchowekIlosc');
    } catch (err) {
      console.log(err);
    }
  },
  async dodajElementDoSchowka({ state, dispatch }, payload) {
    try {
      const body = {
        BloczekId: payload.BloczekId,
        OfertaURLDlaGoogle: payload.BazoweInformacje.OfertaURLDlaGoogle,
        KlientId: state.klientId,
      };

      await this.$http.$post(`${apiUrls.schowek}dodaj`, body);
      dispatch('setSchowekIlosc');
    } catch (err) {
      console.log(err);
    }
  },
};
